import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'react-select';

export default function ProjectSelectorMenu(props) {
  let content;
  if (props.isLoading) {
    content = <div className="p-3" name="loading">Searching...</div>;
  } else if (props.selectProps.inputValue) {
    if (props.options.length) {
      return <components.Menu {...props} />;
    } else {
      content = (
        <div className="p-3 project-search-message">
          No marketing properties found
        </div>
      );
    }
  } else {
    return null;
  }

  return <components.Menu {...props}>{content}</components.Menu>;
}

ProjectSelectorMenu.propTypes = {
  isLoading: PropTypes.bool,
  options: PropTypes.array.isRequired,
  selectProps: PropTypes.shape({
    inputValue: PropTypes.string
  })
};
